import axios from 'axios';

function getStats2Endpoint() {
    return window.OPTIONS.properties
        ? window.OPTIONS.properties['stats2.endpoint.url']
        : window.OPTIONS['player']['stats2Endpoint'];
}

export const stats2Client = axios.create({
    baseURL: `${getStats2Endpoint()}/market-statistics`
});

stats2Client.interceptors.response.use(response => response.data);
